import { render, staticRenderFns } from "./selectedProductModal.vue?vue&type=template&id=0b0b0c14&scoped=true"
import script from "./selectedProductModal.vue?vue&type=script&lang=js"
export * from "./selectedProductModal.vue?vue&type=script&lang=js"
import style0 from "./selectedProductModal.vue?vue&type=style&index=0&id=0b0b0c14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b0c14",
  null
  
)

export default component.exports